import React from "react";
import "./CePrivacyStatement.css";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import Header from "../CeHeader/Header";
import Button from '@mui/material/Button';
import withSnackbar from "../../util/withSnackbar";
import { SNACKBAR_OPTIONS } from "../../constants/CommonConstants";

class cePrivacyStatement extends React.Component{

    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    };

    handleClose() {
        this.props.history.push({
            pathname: '/',
        });
    }

    render() {
        return (
            <div id="cePrivacyStatement">
                <Header showSubMenu={false} />
                <div class="form">
                    <div class="title">{this.props.intl.formatMessage({ id: "privacy_statement" })}</div>
                    <div class="content">{this.props.intl.formatMessage({ id: "privacy_statement_contents" })}</div>
                </div>
                <Button onClick={() => this.handleClose()}>{this.props.intl.formatMessage({ id: "header_close" })}</Button>
            </div>
        )
    }

}

export default withSnackbar(withRouter(injectIntl(cePrivacyStatement)), SNACKBAR_OPTIONS);
